import '@fortawesome/fontawesome-free/css/all.min.css'
import '@factry/bulma/scss/bulma.scss'
import { initialize } from '@factry/base'
import settings from '@factry/translation-manager/src/settings'

import App from './App.svelte'
import background from './assets/background.png'
import logo from './assets/logo.png'

initialize({
  availableLocales: ['en', 'nl', 'fr'],
  background,
  basePath: import.meta.env.VITE_BASE_PATH,
  defaultLocale: 'en',
  logo,
  logoAlt: 'Factry Microbrewery',
  test: import.meta.env.VITE_TEST,
  versions: import.meta.env.VITE_VERSIONS,
})

settings.canEditDefaultLocale = true

const app = new App({
  target: document.body,
})

export default app
